import axios from "axios";

// Sales module — mutations. GET reads live via RTK Query (appApi.js).
const API = `${process.env.REACT_APP_API_URL || "http://localhost:5001"}/api/sales`;

export const createSaleApi = (payload) =>
  axios.post(`${API}/records`, payload);

export const updateSaleApi = (id, payload) =>
  axios.patch(`${API}/records/${id}`, payload);

export const cancelSaleApi = (id) =>
  axios.post(`${API}/records/${id}/cancel`, null);
